import { Col, Row, Image } from 'react-bootstrap';
import Default from './layout/Default';
import LoginImage from '../assets/images/login-img.png';
import ChangePasswordForm from '../components/changePassword/ChangePasswordForm';

const ChangePassword = () => {

    return (
        <Default>
            <Row className="loginPage">
                <Col md="6" className='imgLogo mt-4'>
                <h2 className='text-center'><span>Welcome to </span><br/> Virtu Ward </h2>
                <br></br>
                    <Image src={LoginImage} alt="" />
                </Col>
                <Col md="6" className='mt-md-2 mb-5 loginForm'>
                    <ChangePasswordForm />
                </Col>
            </Row>
        </Default>
    )
}

export default ChangePassword;